import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aed414a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notify__inner" }
const _hoisted_2 = { class: "notify__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0C1229",
    d: "m8.828 6 2.122 2.121a2 2 0 0 1-2.829 2.829L6 8.828 3.879 10.95A2 2 0 0 1 1.05 8.121L3.171 6 1.05 3.879A2 2 0 0 1 3.879 1.05L6 3.171 8.121 1.05a2 2 0 0 1 2.829 2.829L8.828 6z"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['notify', `notify--${_ctx.variant}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", {
        class: _normalizeClass(['notify__message', `notify__message--${_ctx.variant}`])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2)
    ]),
    _createElementVNode("button", {
      class: "notify__close-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, _hoisted_4)
  ], 2))
}